import React from 'react';
import { CustomIcon } from './CustomIcon';
export const PainPoints = () => {
  const painPoints = [{
    icon: 'piggy-bank',
    text: 'Te dicen que "ahorres lo que sobra"... pero nunca sobra nada.'
  }, {
    icon: 'calculator',
    text: 'Que "presupuestes como un americano"... usando cuentas que ni existen.'
  }, {
    icon: 'chart',
    text: 'Que "inviertas como los ricos"... pero ni entiendes las apps.'
  }, {
    icon: 'dollar',
    text: 'Que "ganes más"... pero no sabes cómo sobrevivir HOY.'
  }];
  return <section className="py-16 bg-white" data-id="element-244">
      <div className="container mx-auto px-4" data-id="element-245">
        <div className="text-center mb-12" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-247">
            ¿Te Pasó?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-248">
            Estos son los consejos que te han dado y que nunca funcionaron en tu
            realidad.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-249">
          {painPoints.map((point, index) => <div key={index} className="mb-6 bg-red-50 rounded-lg p-6 flex items-start" data-id="element-250">
              <div className="bg-white p-3 rounded-full mr-4 shadow-md" data-id="element-251">
                <CustomIcon name={point.icon} className="text-red-600" size={24} data-id="element-252" />
              </div>
              <p className="text-lg text-gray-800 flex-1" data-id="element-253">{point.text}</p>
            </div>)}
          <div className="mt-10 text-center" data-id="element-254">
            <p className="text-xl text-gray-700 mb-2" data-id="element-255">
              Y tú lo intentaste. Seguiste reglas. Luchaste. Te culpaste.
            </p>
            <p className="text-2xl font-bold text-orange-600" data-id="element-256">
              Pero no eras tú. Era el método. Era el sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
};